import axios from "src/utils/axios";

class MgmtVariantOptions {

  createVariantOption = (payload) =>
    new Promise((resolve, reject) => {
      axios
        .post(
          "/api/admin/catalog/product/variant/options",
          payload
        )
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  getAllVariantOptions = (customerId) =>
  new Promise((resolve, reject) => {
    axios
      .get(
        `/api/admin/catalog/product/variant/options/all?customerId=${customerId}`
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

  updateVariantOption = (payload) =>
  new Promise((resolve, reject) => {
    axios
      .put(
        "/api/admin/catalog/product/variant/options",
        payload
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
  deleteVariantOption = (customerId, variationId) =>
  new Promise((resolve, reject) => {
    axios
      .post(
        `/api/admin/catalog/product/variant/options/delete?customerId=${customerId}&variationId=${variationId}`
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

const mgmtVariantOptions = new MgmtVariantOptions();

export default mgmtVariantOptions;